import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import "./styles/CustomDomainLogo.less";

const CustomDomainLogo = observer(({ logoUrl, company }) => {
  if (!logoUrl) {
    return (
      <div className="custom-domain-logo">
        <h2>{company}</h2>
      </div>
    );
  }

  return (
    <div className="custom-domain-logo">
      <div className="custom-domain-logo-wrap">
        <img src={logoUrl} alt={company} />
      </div>
      <h2>{company}</h2>
    </div>
  );
});

CustomDomainLogo.propTypes = {
  logoUrl: PropTypes.string,
  company: PropTypes.string.isRequired,
};

export default CustomDomainLogo;
